var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"e-btn",class:{'e-btn-primary': _vm.color === 'primary', 'e-button-icon': _vm.icon, 'e-disabled': _vm.disabled, 'i-btn-sm' : _vm.sm},attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.click,"mouseover":_vm.mouseover}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b585407","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/button.vue
// module id = null
// module chunks = 